import gql from 'graphql-tag';

export const UPLOAD_LEAD_IDS_MUTATION = gql`
  mutation uploadLeadIds($testatorId: ID!, $fileBase64: String!) {
    uploadLeadIds(testatorId: $testatorId, fileBase64: $fileBase64) {
      fileBase64
    }
  }
`;

export const UPLOAD_IWIZE_JOB_LIST_MUTATION = gql`
  mutation uploadIwyzeJobList($testatorId: ID!, $fileBase64: String!) {
    uploadIwyzeJobList(testatorId: $testatorId, fileBase64: $fileBase64) {
      id
      status
      progress
      totalRows
      processedRows
      errorMessage
    }
  }
`;

export const UPLOAD_EXTERNAL_LEAD_LIST_MUTATION = gql`
  mutation uploadExternalLeadList(
    $testatorId: ID!
    $fileBase64: String!
    $type: String!
  ) {
    uploadExternalLeadList(
      testatorId: $testatorId
      fileBase64: $fileBase64
      type: $type
    ) {
      id
      status
      progress
      totalRows
      processedRows
      errorMessage
    }
  }
`;

export const POLL_IWYZE_JOB_LIST_STATUS_MUTATION = gql`
  mutation pollIwyzeJobListStatus($testatorId: ID!) {
    pollIwyzeJobListStatus(testatorId: $testatorId) {
      id
      status
      progress
      totalRows
      processedRows
      hasChangesApplied
      errorMessage
    }
  }
`;

export const POLL_EXTERNAL_LEAD_JOB_LIST_STATUS_MUTATION = gql`
  mutation pollExternalLeadJobListStatus($testatorId: ID!, $type: String!) {
    pollExternalLeadJobListStatus(testatorId: $testatorId, type: $type) {
      id
      status
      progress
      totalRows
      processedRows
      errorMessage
    }
  }
`;

export const PROCESS_EXCEL_FILE_MUTATION = gql`
  mutation processExcelFile(
    $testatorId: ID!
    $fileBase64: String!
    $action: String!
  ) {
    processExcelFile(
      testatorId: $testatorId
      fileBase64: $fileBase64
      action: $action
    ) {
      id
    }
  }
`;

export const APPLY_DEATH_CHECK_LIST_CHANGES_MUTATION = gql`
  mutation applyDeathCheckListChanges(
    $testatorId: ID!
    $deathCheckListJobId: String!
  ) {
    applyDeathCheckListChanges(
      testatorId: $testatorId
      deathCheckListJobId: $deathCheckListJobId
    ) {
      statusCode
      message
    }
  }
`;

export const UPLOAD_PF_ADVISER_SEED_MUTATION = gql`
  mutation uploadPfAdviserSeed($testatorId: ID!, $fileBase64: String!) {
    uploadPfAdviserSeed(testatorId: $testatorId, fileBase64: $fileBase64) {
      id
      status
      progress
      totalRows
      processedRows
      errorMessage
    }
  }
`;

export const POLL_PF_ADVISER_SEED_STATUS_MUTATION = gql`
  mutation pollPfAdviserSeedStatus($testatorId: ID!) {
    pollPfAdviserSeedStatus(testatorId: $testatorId) {
      id
      status
      progress
      totalRows
      processedRows
      uniqueCodes
      matchedCount
      unmatchedCount
      hasChangesApplied
      errorMessage
      pfAdviserSeedActions {
        id
        intermediaryCode
        intermediaryName
        advisorChannel
        advisorRegion
        advisorArea
        advisorTeam
        advisorEmploymentStatus
        user {
          id
          fullName
          advisorCode
        }
      }
    }
  }
`;

export const APPLY_PF_ADVISER_SEED_CHANGES_MUTATION = gql`
  mutation applyPfAdviserSeedChanges(
    $testatorId: ID!
    $pfAdviserSeedJobId: String!
  ) {
    applyPfAdviserSeedChanges(
      testatorId: $testatorId
      pfAdviserSeedJobId: $pfAdviserSeedJobId
    ) {
      statusCode
      message
    }
  }
`;

export const DOWNLOAD_MONTHLY_DEATH_CHECK_LIST_MUTATION = gql`
  mutation downloadMonthlyDeathCheckList($testatorId: ID!) {
    downloadMonthlyDeathCheckList(testatorId: $testatorId) {
      id
      s3FileUrl
      fileName
      processing
    }
  }
`;

export const FETCH_MONTHLY_DEATH_CHECK_LISTS_MUTATION = gql`
  mutation fetchMonthlyDeathCheckLists($testatorId: ID!) {
    fetchMonthlyDeathCheckLists(testatorId: $testatorId) {
      id
      s3FileUrl
      fileName
      processing
    }
  }
`;

export const FETCH_DAILY_TASK_DOWNLOAD_MUTATION = gql`
  mutation fetchDailyTaskDownload($testatorId: ID!, $action: String!) {
    fetchDailyTaskDownload(testatorId: $testatorId, action: $action) {
      id
      s3FileUrl
      fileName
      processing
      presignedUrl
    }
  }
`;

export const FETCH_UPLOADED_DEATH_CHECK_LIST_MUTATION = gql`
  mutation fetchUploadedDeathCheckList(
    $testatorId: ID!
    $deathCheckListId: ID!
  ) {
    fetchUploadedDeathCheckList(
      testatorId: $testatorId
      deathCheckListId: $deathCheckListId
    ) {
      url
    }
  }
`;

export const UPLOAD_TESTATOR_IDS_MUTATION = gql`
  mutation uploadTestatorIds($idType: String!, $fileBase64: String!) {
    uploadTestatorIds(idType: $idType, fileBase64: $fileBase64) {
      id
      s3FileUrl
      fileName
      processing
    }
  }
`;

export const FETCH_TESTATOR_BASIC_INFO_LISTS_MUTATION = gql`
  mutation fetchTestatorBasicInfoLists {
    fetchTestatorBasicInfoLists {
      id
      s3FileUrl
      fileName
      processing
    }
  }
`;

export const FETCH_UPLOADED_TESTATOR_BASIC_INFO_LIST_MUTATION = gql`
  mutation fetchUploadedTestatorBasicInfoList($testatorBasicInfoListId: ID!) {
    fetchUploadedTestatorBasicInfoList(
      testatorBasicInfoListId: $testatorBasicInfoListId
    ) {
      url
    }
  }
`;

export const TEST_DAILY_TASK_MUTATION = gql`
  mutation testDailyTask(
    $testatorId: ID!
    $action: String!
    $seedCount: Int
    $command: String
    $dangerZonePassword: String
  ) {
    testDailyTask(
      testatorId: $testatorId
      action: $action
      seedCount: $seedCount
      command: $command
      dangerZonePassword: $dangerZonePassword
    ) {
      success
      result
    }
  }
`;

export const DOWNLOAD_LIST_MUTATION = gql`
  mutation downloadList($type: String!) {
    downloadList(type: $type) {
      id
      status
      progress
      totalRows
      processedRows
      errorMessage
      fileURL
    }
  }
`;

export const POLL_DOWNLOAD_LIST_STATUS_MUTATION = gql`
  mutation pollDownloadListStatus($type: String!) {
    pollDownloadListStatus(type: $type) {
      id
      status
      progress
      totalRows
      processedRows
      errorMessage
      fileURL
    }
  }
`;
